import { setShippingCharges } from "../../reducers/common";
import service from "../index";

export const setSystemCharges = (apiData) => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post(
        "/SystemChargesSettings/AddEditSystemCharges",
        apiData
      );
      resolve(res?.data);
    } catch (err) {
      reject(err?.data);
    }
  });
};

export const getSystemCharges = () => async (dispatch) => {
  return new Promise(async (resolve, reject) => {
    try {
      const res = await service.post(
        "/SystemChargesSettings/GetShippingCharges"
      );
      resolve(res?.data);
      dispatch(setShippingCharges(res?.data));
    } catch (err) {
      reject(err?.data);
    }
  });
};
